/**
 * @module components/global-tenants/utilities/gt-secure-fdic-utility/js/index
 * @author Manasa Uppula manasa.uppula@bofa.com
 * @author Montier Elliott montier.elliott@bofa.com
 *
 */

/**
 * FDIC Utility
 * Will add gt-secure-fdic-widget to any sparta page
 *
 *
 *
 * @class
 */
class FDIC {
  /**
   * Constructor
   *
   *
   *
   */
  constructor() {
    /** Widget Version */
    this.widgetVersion = "1.0.0";

    /** Loader Version */
    this.LOADER_VERSION = "6.0.5";

    /** Widget Name */
    this.widgetName = "gt-secure-fdic-widget";

    /** Widget Language */
    this.DEFAULT_LANGUAGE = "en";

    /** FDIC Interstitial */
    this.fdicInterstitial = "fdicInterstitial";

    /** Widget Initialize Name */
    this.widgetsInitName = "fdic.initialWidgetLoader";

    /** Widget Container */
    this.widgetContainer = "gtSecureFdicWidgetContainer";

    /** Widget Base URL */
    this.widgetBaseURL = this.configureWidgetBaseURL();

    /** Enable Sparta */
    this.isPlatformSparta = this.isSpartaEnabled();

    /** Check Spanish Page */
    this.widgetLanguage = this.isFDICWidgetSpanish();

    /** Universal Header Module on Document Object Model */
    this.universalModuleOnDOM = this.isUniversalHeaderModuleInDOM();

    /** Is FDIC Widget Enabled */
    this.isWidgetEnabled = this.isFDICWidgetEnabled();

    /** IF FDIC Widget is not enabled disable FDIC */
    if (!this.isWidgetEnabled) return false;

    /** Widget Configuration */
    this.widgetConfiguration = this.configureFDICWidget();

    /** Existing Widget Loader */
    this.existingWidgetLoader = this.widgetLoaderExist();

    /** Widget Container Exist */
    this.existingWidgetContainer = this.isGTSecureFdicWidgetContainer();

    /** Start FDIC Feature || Important || Starting point */
    if (this.existingWidgetContainer) {
      this.start();
    }
  }

  /**
   * Is Universal Header Module In DOM
   *
   *
   *
   * @returns {boolean}
   */
  isUniversalHeaderModuleInDOM() {
    const $module = document.getElementById("universalHeaderModule");
    return document.body.contains($module);
  }

  /**
   * Is GT Secure FDIC Widget Container
   * 
   * 
   * 
   * @returns {boolean}
   */
  isGTSecureFdicWidgetContainer() {
    const $module = document.getElementById('gtSecureFdicWidgetContainer');
    return document.body.contains($module);
  }

  /**
   * Configure Widget Base URL
   *
   *
   *
   * TODO https://secure-dev4-helix.ecnp.bankofamerica.com/
   * @returns {string}
   */
  configureWidgetBaseURL() {
    const siteParams = window?.spaParams?.siteParams;

    // Localhost
    if (siteParams?.env === "local") return "http://localhost:3005";

    // Consumer sales site
    if (siteParams?.securefdicHost) return siteParams?.securefdicHost;

    // Sparta Site
    if (siteParams?.secureHost) return siteParams?.secureHost;

    // Bill.com
    const $universalWidget = "universal-nav-bill-com-widget";
    const universalWidget = window?.spaWidgetParams?.[$universalWidget]?.["1.0.0"]?.siteParams;
    if (universalWidget) return universalWidget?.secureHost;

    // Use Production
    return "https://secure.bankofamerica.com/";
  }

  /**
   * Is FDIC Widget Enabled
   *
   *
   *
   * @returns {boolean}
   */
  isFDICWidgetEnabled() {
    /** If Universal Header Module mandatory */
    const universalHeaderModuleExist = this.universalModuleOnDOM;
    const $universalWidget = "universal-nav-bill-com-widget";
    const spartaSiteParams = window?.spaParams?.siteParams;
    const spartaPageParams = window?.spaParams?.pageParams;
    const noSpartaFDIC = window?.globalTenants?.widgets;
    const universalWidget = window?.spaWidgetParams?.[$universalWidget]?.["1.0.0"]?.siteParams;
    if (spartaPageParams?.globalTenants?.widgets?.fdic) return spartaPageParams?.globalTenants?.widgets?.fdic;
    if (spartaSiteParams?.globalTenants?.widgets?.fdic) return spartaSiteParams?.globalTenants?.widgets?.fdic;
    if (universalHeaderModuleExist) return true;
    if (universalWidget?.fdic) return true;
    if (noSpartaFDIC?.fdic) return noSpartaFDIC?.fdic;
    return false;
  }

  /**
   * Is FDIC Widget Spanish
   * 
   * 
   * 
   * 
   * @returns {string}
   */
  isFDICWidgetSpanish() {
    /** Extract Query Params */
    const queryParameters = new URLSearchParams(window.location.search);

    /** Extract DOM Elements */
    const $html = document.getElementsByTagName("html")?.[0];
    const $body = document.getElementsByTagName("body")?.[0];

    /** Read Cookie Language */
    const localeCookie = this.readCookie({
      prop: 'BOFA_LOCALE_COOKIE'
    });

    /** Digital Data Language */
    const digitalDataLanguage = window?.digitalData?.page?.pageInfo?.[0]?.language?.toLowerCase();

    /** Query Param Language */
    const requestLocaleQueryParam = queryParameters?.get('request_locale')?.toLowerCase();

    /** HTML Language */
    const htmlLanguage = $html?.getAttribute('lang');

    /** Body Language */
    const bodyLanguage = $body?.getAttribute('lang');
    if (requestLocaleQueryParam?.includes('es')) return 'es';
    if (localeCookie?.includes('es')) return 'es';
    if (digitalDataLanguage?.includes('es')) return 'es';
    if (htmlLanguage?.includes('es')) return 'es';
    if (bodyLanguage?.includes('es')) return 'es';
    if (window?.spaParams?.language?.includes('es')) return 'es';
    if (window?.gtFDIC?.language?.includes('es')) return 'es';

    /** English */
    return 'en';
  }

  /**
   * Configure FDIC Widget
   *
   *
   *
   *
   * @returns {object}
   */
  configureFDICWidget() {
    const fdicWidgetData = {
      fdic: this.isWidgetEnabled
    };
    const fdicWidgetConfiguration = {
      spinner: false,
      name: this.widgetName,
      path: this.widgetBaseURL,
      version: this.widgetVersion,
      language: this.widgetLanguage,
      container: this.widgetContainer,
      loaderVersion: this.LOADER_VERSION,
      options: {
        data: fdicWidgetData,
        withoutCredentials: true
      }
    };
    return fdicWidgetConfiguration;
  }

  /**
   * Widget Loader Exist
   *
   *
   *
   * @returns {boolean}
   */
  widgetLoaderExist() {
    return window?.sparta && window?.sparta?.widgetLoader && window?.sparta?.widgetLoader?.[this.LOADER_VERSION];
  }

  /**
   * Enabled Sparta
   *
   *
   *
   * @returns {boolean}
   */
  isSpartaEnabled() {
    if (!window?.sparta) return false;
    return true;
  }

  /**
   * Load Widget
   *
   *
   *
   *
   * @returns {void}
   */
  loadWidget() {
    window?.sparta?.widgetLoader?.[this.LOADER_VERSION]?.load(this.widgetConfiguration);
  }

  /**
   * Load Widget Loader
   *
   *
   *
   *
   * @returns {void}
   */
  loadWidgetLoader() {
    const loader = document.createElement("script");
    loader.type = "text/javascript";
    const loaderPath = `/spa/widgets/loader/${this.LOADER_VERSION}/index.js`;
    loader.src = `${this.widgetBaseURL}${loaderPath}`;
    loader.dataset.widgetName = this.widgetsInitName;
    loader.onload = this.loadWidget.bind(this);
    document.body.appendChild(loader);
  }

  /**
   * Start
   *
   *
   *
   *
   * @returns {void}
   */
  start() {
    if (!this.existingWidgetLoader) {
      this.loadWidgetLoader();
      return;
    }
    this.loadWidget();
  }

  /**
   * Read Cookie
   * 
   * 
   * 
   * 
   * @param {prop}
   * @returns {string}
   */
  readCookie({
    prop
  }) {
    return document.cookie.split("; ").find(row => row.startsWith(prop))?.split("=")[1]?.split("-")[0];
  }
}

/** On Demand */
new FDIC();

export { FDIC };
